import {AuthNgrx, emptyAuth} from '~model/ngrx/auth-ngrx';
import {Action, createReducer, on} from '@ngrx/store';
import {authLogin, authReiniciar, authSet} from './feature-auth.actions';

const initialState: AuthNgrx = emptyAuth();

const reducer = createReducer(
  initialState,
  on(authSet, (state, action: AuthNgrx) => (action)),
  on(authLogin, _ => _),
  on(authReiniciar, _ => (initialState))
);

export const featureAuthReducer = (state: AuthNgrx, action: Action) => reducer(state, action);
